var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-row',{staticClass:"AtobaraiNgDetail"},[_c('span',[_c('app-text',[_vm._v("決済失敗の理由について詳しくは")]),_c('app-link',{attrs:{"to":_vm.NG_REASON_DETAIL_URL}},[_vm._v("こちら")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }